import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "entertainment" }
const _hoisted_2 = { class: "fzqj-box" }
const _hoisted_3 = { class: "fzqj" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "fays" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "yycj" }
const _hoisted_20 = { class: "yycj-content" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "yyal" }
const _hoisted_23 = { class: "yyal-content" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "detail" }
const _hoisted_29 = { class: "pagination" }
const _hoisted_30 = ["onClick"]

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import SubTitle from '@/components/SubTitle.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'EntertainmentPlan',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref({})
const casesListAll: any = ref([])
const prospects: any = ref(
  [
    {
      title: '消费升级',
      content: '当下，国内新型消费潜力迸发，以沉浸式旅游、文化旅游等为特点的文娱旅游正成为各地积极培育的消费增长点。同时，数实融合不断深化，实体经济数字化、智能化、绿色化转型不断加快，为经济社会发展持续赋能。',
    },
    {
      title: '政策引领',
      content: '工信部等五部门联合印发《元宇宙产业创新发展三年行动计划（2023-2025年）》，北上广深、南京等数十个城市纷纷出台元宇宙发展相关政策，希望借势元宇宙的机会加速传统产业数字化转型并大力发展数字经济，结合地方特色打造丰富的元宇宙标杆场景和应用。',
    },
    {
      title: '数智未来',
      content: '人类社会数字化、智能化是不可逆的发展趋势，AIGC的应用将会极大的提高人类的生产效率，也将会加快数实融合、数实互促、元宇宙的模态到来。',
    }
  ]
)
const paginationIndex = ref(0)
const paginationValue = ref(1)

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `解决方案 / 文娱解决方案 / ${title}`
}

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  casesList.value = [...casesListAll.value].slice((value - 1) * 5, value * 5)
}

// onMounted(() => {
//   selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
//     casesListAll.value = [...res].filter(e => e.industry == 1)
//     casesList.value = [...casesListAll.value].slice(0, 5)
//     paginationValue.value = Math.ceil(casesListAll.value?.length / 5) || 0
//   })
// })

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesListAll.value.length === 0) {
    selectCommonElement({ columnId: 4, appId: 2, createTimeOrder: 1 }).then((res: any) => {
      casesListAll.value = [...res].filter(e => e.industry == 1).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
      casesList.value = [...casesListAll.value].slice(paginationIndex.value * 5, (paginationIndex.value + 1) * 5)
      paginationValue.value = Math.ceil(casesListAll.value?.length / 5) || 0
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.positioning) {
    const positioning: any = await asynchronousRetrieval('nfznxr-images/jjfa/positioning.png');
    const triangle: any = await asynchronousRetrieval('nfznxr-images/jjfa/triangle.png');
    const arrange: any = await asynchronousRetrieval('nfznxr-images/jjfa/arrange.png');
    const edit: any = await asynchronousRetrieval('nfznxr-images/jjfa/edit.png');
    const application: any = await asynchronousRetrieval('nfznxr-images/jjfa/application.png');
    const fzqj1: any = await asynchronousRetrieval('nfznxr-images/jjfa/fzqj1.png');
    const xiaofei: any = await asynchronousRetrieval('nfznxr-images/jjfa/xiaofei.png');
    const fzqj2: any = await asynchronousRetrieval('nfznxr-images/jjfa/fzqj2.png');
    const zhengce: any = await asynchronousRetrieval('nfznxr-images/jjfa/zhengce.png');
    const fzqj3: any = await asynchronousRetrieval('nfznxr-images/jjfa/fzqj3.png');
    const shuzhi: any = await asynchronousRetrieval('nfznxr-images/jjfa/shuzhi.png');
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    const entertainmentMp4: any = await asynchronousRetrieval('webimg/gif/entertainment.gif');
    loadUrl.value = { positioning, triangle, arrange, edit, application, fzqj1, xiaofei, fzqj2, zhengce, fzqj3, shuzhi, fays_bg, entertainmentMp4 }

    prospects.value[0].url = fzqj1
    prospects.value[0].src = xiaofei
    prospects.value[1].url = fzqj2
    prospects.value[1].src = zhengce
    prospects.value[2].url = fzqj3
    prospects.value[2].src = shuzhi
  }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title-font-style" }, "文娱解决方案", -1)),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "illustrate" }, [
      _createElementVNode("div", null, "将元宇宙与内容资源融合创新，应用虚拟现实和新媒体技术打造沉浸式的时空新体验，实现“文化+科技”“文娱+消费”的新业态模式，推动文娱产业升级。")
    ], -1)),
    _createVNode(SubTitle, { "title-text": "发展前景" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prospects.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("img", {
              src: item.url
            }, null, 8, _hoisted_4),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.src
                }, null, 8, _hoisted_6),
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("div", null, _toDisplayString(item.content), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(SubTitle, { "title-text": "方案优势" }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_8),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: loadUrl.value.positioning
        }, null, 8, _hoisted_9),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "l2" }, "空间定位", -1)),
        _createElementVNode("img", {
          class: "l3",
          src: loadUrl.value.triangle
        }, null, 8, _hoisted_10),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "l4" }, "准", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "l5" }, [
          _createElementVNode("div", null, "自研空间定位算法"),
          _createElementVNode("div", null, "厘米级视觉定位"),
          _createElementVNode("div", null, "空间导航精准"),
          _createElementVNode("div", null, "支持大空间定位")
        ], -1))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: loadUrl.value.arrange
        }, null, 8, _hoisted_11),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "l2" }, "交付部署", -1)),
        _createElementVNode("img", {
          class: "l3",
          src: loadUrl.value.triangle
        }, null, 8, _hoisted_12),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "l4" }, "快", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "l5" }, [
          _createElementVNode("div", null, "SaaS化服务"),
          _createElementVNode("div", null, "快速调整内容布局"),
          _createElementVNode("div", null, "2天内完成空间构建"),
          _createElementVNode("div", null, "现场体验式交付")
        ], -1))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: loadUrl.value.edit
        }, null, 8, _hoisted_13),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "l2" }, "场景编辑", -1)),
        _createElementVNode("img", {
          class: "l3",
          src: loadUrl.value.triangle
        }, null, 8, _hoisted_14),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "l4" }, "简", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "l5" }, [
          _createElementVNode("div", null, "3D场景地图"),
          _createElementVNode("div", null, "可视化交互"),
          _createElementVNode("div", null, "“拖拉拽”操作"),
          _createElementVNode("div", null, "所“建”即所得")
        ], -1))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: loadUrl.value.application
        }, null, 8, _hoisted_15),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "l2" }, "支持应用", -1)),
        _createElementVNode("img", {
          class: "l3",
          src: loadUrl.value.triangle
        }, null, 8, _hoisted_16),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "l4" }, "多", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "l5" }, [
          _createElementVNode("div", null, "XR眼镜"),
          _createElementVNode("div", null, "移动端APP"),
          _createElementVNode("div", null, "小程序AR"),
          _createElementVNode("div", null, "Web")
        ], -1))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "l1",
          src: loadUrl.value.positioning
        }, null, 8, _hoisted_17),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "l2" }, "内容扩展性", -1)),
        _createElementVNode("img", {
          class: "l3",
          src: loadUrl.value.triangle
        }, null, 8, _hoisted_18),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "l4" }, "强", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "l5" }, [
          _createElementVNode("div", null, "数字多媒体"),
          _createElementVNode("div", null, "动画特效"),
          _createElementVNode("div", null, "手势互动"),
          _createElementVNode("div", null, "3D数字人")
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(SubTitle, { "title-text": "应用场景" }),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("img", {
          src: loadUrl.value.entertainmentMp4
        }, null, 8, _hoisted_21)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(SubTitle, { "title-text": "应用案例" }),
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(casesList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (toDetail(item.relatedHtmlId, item.title)),
            key: index
          }, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_25),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(item.title), 1),
              _createElementVNode("div", null, _toDisplayString(item.subTitle), 1),
              _createElementVNode("div", _hoisted_28, _toDisplayString(item.introduction), 1)
            ])
          ], 8, _hoisted_24))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", {
          class: "prev",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeData(Math.max(0, paginationIndex.value - 1) + 1)))
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationValue.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (changeData(item)),
            class: _normalizeClass(paginationIndex.value == index ? 'active' : ''),
            key: item
          }, _toDisplayString(item), 11, _hoisted_30))
        }), 128)),
        _createElementVNode("div", {
          class: "next",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeData(Math.min(paginationIndex.value + 1, paginationValue.value - 1) + 1)))
        })
      ])
    ])
  ]))
}
}

})